import { KpiTile as DsKpi } from "procurement/design"

const KpiTile = ({ label, value, hint, onClick, emphasis, danger }) => (
  <DsKpi label={label} value={value} hint={hint} onClick={onClick} emphasis={emphasis} danger={danger} />
)

export default KpiTile
